"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _moment = require("moment");

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: ["occasion", "test", "showDownloadPdfButton", "projectId"],

  computed: {
    canEditOccasion: function canEditOccasion() {
      var isOccasionHasPassed = (0, _moment2.default)(this.occasion.end_date).endOf("day").isBefore((0, _moment2.default)());

      return !window.Fn.isTestLeader() && !isOccasionHasPassed && this.test && this.test.type.template_type === "questionnaire";
    }
  },

  methods: {
    getPrintPdfLink: function getPrintPdfLink() {
      return this.projectId ? "/admin/project/" + this.projectId + "/test/" + this.test.id + "/print" : "/test/" + this.test.id + "/print";
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


//////////////////
// WEBPACK FOOTER
// ./~/babel-loader/lib?cacheDirectory!./~/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/tests/TestSummary.vue
// module id = N8bc
// module chunks = 0 1